import type React from 'react';
import ProtectedRoute from '../platform/auth/components/ProtectedRoute';
import LayoutShell from './LayoutShell';

type ProtectedLayoutRouteProps = React.ComponentProps<typeof LayoutShell>;

export default function ProtectedLayoutRoute({
  children,
  ...layoutProps
}: ProtectedLayoutRouteProps): React.ReactElement {
  return (
    <ProtectedRoute>
      <LayoutShell {...layoutProps}>{children}</LayoutShell>
    </ProtectedRoute>
  );
}
